"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoordinate = exports.setMapCenter = void 0;
const lodash_1 = require("lodash");
exports.setMapCenter = (map, center) => {
    map.panTo(new google.maps.LatLng(center.lat, center.lng));
    map.setCenter(new google.maps.LatLng(center.lat, center.lng));
};
exports.isCoordinate = (coor) => {
    return !!(coor && coor.lng && coor.lat && lodash_1.isNumber(coor.lat) && lodash_1.isNumber(coor.lng));
};
